import { User } from 'src/components/pipelines/models/User';

export enum TestCaseActions {
  MARKED_FLAKY = 'MARKED_FLAKY',
  MARKED_OK = 'MARKED_OK',
  MARKED_QUARANTINE = 'MARKED_QUARANTINE',
  UNMARKED_QUARANTINE = 'UNMARKED_QUARANTINE',
}

export enum TestOutcomeEnum {
  Passed = 'SUCCESSFUL',
  Failed = 'FAILED',
  Skipped = 'SKIPPED',
  Error = 'ERROR',
}

export enum TargetTypeEnum {
  Reference = 'REFERENCE',
  Commit = 'COMMIT',
  'Pull request' = 'PULL_REQUEST',
  Unknown = 'UNKNOWN',
}

export enum TestStatusEnum {
  flaky = 'FLAKY',
  quarantined = 'QUARANTINED',
}

export enum TestTypeEnum {
  Flaky = 'flaky',
  Ok = 'ok',
  Quarantined = 'quarantined',
}

export enum TestCaseAttribute {
  FLAKY = 'flaky',
}

export enum ExecutionStrategy {
  DEFAULT = 'default',
  QUARANTINED = 'quarantined',
}

export type TestCase = {
  uuid: string;
  fullyQualifiedName: string;
  name: string;
  className: string;
  suiteName: string;
  customProperties: Array<{ key: string; value: string }>;
  metricsUpdatedTime?: string;
  attributes: TestCaseAttribute[];
  executionStrategy: ExecutionStrategy;
  metrics: {
    p90DurationInMillis: number;
    averageDurationInMillis: number;
    failureCorrelation?: number;
    failureRate: number;
    flakinessScore?: number;
    numberOfTests?: number;
    varianceInMillis: number;
  };
};

export type TestCases = {
  values: Array<TestCase>;
  page: number;
  pagelen: number;
  size: number;
};

export type TestExecution = {
  uuid: string;
  testReportUuid: string;
  testSummaryUuid: string;
  runUuid?: string;
  fullyQualifiedName: string;
  name: string;
  className: string;
  suiteName: string;
  packageName?: string;
  buildNumber: number;
  target: {
    commit: {
      hash: string;
      message: string;
    };
    referenceName: string;
    revision: string;
    type: string;
  };
  pipelineUuid: string;
  stepUuid: string;
  customTestProperties: Array<{ key: string; value: string }>;
  customSummaryProperties: Array<{ key: string; value: string }>;
  createdOn: string;
  duration: string;
  status: TestOutcomeEnum;
  executionTime?: number;
  averageExecutionTime?: number;
  reason?: {
    testCaseUuid: string;
    uuid: string;
    message: string;
    stackTrace: string;
  };
};

export type TestExecutions = {
  values: Array<TestExecution>;
  page: number;
  pagelen: number;
  size: number;
};

export type SortData = {
  key: string;
  sortOrder?: 'ASC' | 'DESC';
};

export type FixFlakyTestStatus = {
  actionTriggerUuid: string;
  createdAt: string;
  lastUpdatedAt: string;
  status: string;
  createdByUser: User;
  pipeline: {
    type: string;
    uuid: string;
    buildNumber: number;
  };
  pullRequest?: {
    id: number;
    link: string;
  };
};
